// ink-component
import React, { useContext } from 'react';
import { ThemeContext } from 'styled-components';

import CoreFilePicker from './components/CoreFilePicker/CoreFilePicker';
import TableFilePicker from './components/TableFilePicker/TableFilePicker';

export interface File {
  name: string;
  pk?: string;
  url?: string;
}

export interface HttpClient {
  // eslint-disable-next-line @typescript-eslint/ban-types
  all: Function;
  // eslint-disable-next-line @typescript-eslint/ban-types
  post: Function;
}

export interface FilePickerProps {
  /** Unique identifier */
  id: string;
  /** External control and initial value */
  value?: File[];
  /** Unique name */
  name?: string;
  /** Choose/Drop file callback. Passes the value */
  // eslint-disable-next-line @typescript-eslint/ban-types
  onChange?: Function;
  /** onBlur callback. Passes the value */
  // eslint-disable-next-line @typescript-eslint/ban-types
  onBlur?: Function;
  /** onFocus callback. Passes the value */
  // eslint-disable-next-line @typescript-eslint/ban-types
  onFocus?: Function;
  /** Delete callback. Passes the value */
  // eslint-disable-next-line @typescript-eslint/ban-types
  onDelete: Function;
  /** Callback to set `multiple` prop dinamically */
  // eslint-disable-next-line @typescript-eslint/ban-types
  setMultiple?: Function;
  /** Modifier for tables */
  isCell?: boolean;
  /** Modifier for not valid state */
  isInvalid?: boolean;
  /** Modifier for loading */
  isLoading?: boolean;
  /** Modifier for disabled state */
  disabled?: boolean;
  /** Size modifier */
  size?: 'full' | 'large';
  /** Allow specific types of files */
  accept?: string;
  /** Flag for multiple files */
  multiple?: boolean;
  /** HTML type */
  autoFocus?: boolean;
  /** Custom error message */
  customError?: string;
  /** Marks the element with a given ID to make it easier to select in tests */
  'data-testid'?: string | number;
  /** Allows screen readers to describe the content. The correct use of Field excludes the need for aria-label */
  'aria-label'?: string;

  /** @ignore */
  style?: Record<string, unknown>;
  /** @ignore */
  className?: string;
}

/**
 * @purpose Allows users to upload, view and delete one or more files
 * @categories form
 * @aka file upload
 */
function FilePicker(props: FilePickerProps) {
  const { style, className, 'data-testid': dataTestId, ...otherProps } = props;
  const themeContext = useContext(ThemeContext);

  if (themeContext && themeContext.cellPreset === 'editable') {
    return <TableFilePicker {...otherProps} data-testid={dataTestId} />;
  }

  return <CoreFilePicker {...otherProps} data-testid={dataTestId} />;
}

FilePicker.defaultProps = {
  value: [],
  name: undefined,
  multiple: false,
  onFocus: () => {},
  onChange: () => {},
  onBlur: () => {},
  onDelete: () => {},
  setMultiple: () => {},
  accept: undefined,
  size: 'large',
  isCell: false,
  isLoading: false,
  disabled: false,
  isInvalid: false,
  autoFocus: false,
  customError: undefined,
  'data-testid': undefined,
};

FilePicker.displayName = 'FilePicker';

export default FilePicker;
